<template>
	<div :class="['merchant_layout', { lnb }]">
		<Header v-if="!menuChange">
			<menu-routes
				:key="$route"
				:items="gnb_items"
				:class="{ menu_area: false }"
			></menu-routes>
		</Header>
		<HeaderM v-else></HeaderM>

		<div class="container-wrap">
			<div class="container-box">
				<div class="store_container">
					<div class="merchant_lnb card">
						<div class="store_menu">
							<div>
								<h3 v-if="lnb_title">
									<img :src="iconCustomerServiceTitle" alt="" />
									{{ $t(lnb_title) }}
								</h3>
								<ul class="customer_info_menu">
									<li v-for="item in lnb_item" :key="item.name">
										<router-link :to="{ name: item.name }">{{
											$t(item.title)
										}}</router-link>
									</li>
								</ul>
							</div>
							<div class="operating_time">
								<div class="border_bottom mb_15">
									<p>{{ $t('banner2.text1') }}</p>
									<span>10:00 - 19:00<br />{{ $t('banner2.text2') }} </span>
								</div>
								<div class="border_bottom mb_15">
									<p>{{ $t('banner2.text3') }}</p>
									<span
										>{{ $t('banner2.text4') }}<br />
										{{ $t('banner2.text5') }}
									</span>
								</div>
								<div>
									<p>{{ $t('banner2.text6') }}</p>
									<span>10:00 - 19:00<br />{{ $t('banner2.text7') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="merchant_content"><router-view></router-view></div>
				</div>
			</div>
		</div>
		<div class="copyright">
			{{ $t('new_ui.components.footer_component.copyright.text') }}
		</div>
	</div>
</template>
<script>
import Header from '@/components/Layout/Header';
import HeaderM from '@/components/Layout/Header.m';
import MenuRoutes from '@/components/Menu/Routes.vue';
import iconCustomerServiceTitle from '@/assets/images/v2/icon/icon-customer-service-title.svg';

export default {
	name: 'Layout',
	props: {
		lnb: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			gnb_items: [
				{
					name: 'merchant-console-catalog',
					title: 'menu.merchant-console-catalog',
				},
				{
					name: 'merchant-console-transaction-list',
					title: 'menu.merchant-console-transaction-list',
				},
				{
					name: 'merchant-console-settlement_account',
					title: 'menu.merchant-console-settlement_account',
				},
				{
					name: 'merchant-console-cs-notice',
					title: 'menu.merchant-console-cs-notice',
				},
				// {
				// 	name: 'merchant-console-certification-kyc',
				// 	title: 'menu.merchant-console-certification-kyc',
				// },
				{
					name: 'auth-dashboard',
					title: 'menu.merchant.personal',
				},
			],
			lnb_items: {
				cs: [
					{
						name: 'merchant-console-cs-notice',
						title: 'merchant.menu_2.menu1',
					},
					{
						name: 'merchant-console-cs-inquiry',
						title: 'merchant.menu_2.menu2',
					},
					{
						name: 'merchant-console-cs-inquiry-list',
						title: 'merchant.menu_2.menu3',
					},
					{ name: 'merchant-console-cs-faq', title: 'merchant.menu_2.menu4' },
				],
				// certification: [
				// 	{
				// 		name: 'merchant-console-certification-kyc',
				// 		title: 'merchant.menu_2.menu5',
				// 	},
				// 	{
				// 		name: 'merchant-console-certification-email',
				// 		title: 'merchant.menu_2.menu6',
				// 	},
				// 	{
				// 		name: 'merchant-console-certification-otp',
				// 		title: 'merchant.menu_2.menu7',
				// 	},
				// 	{
				// 		name: 'merchant-console-certification-security',
				// 		title: 'merchant.menu_2.menu9',
				// 	},
				// ],
			},
			lnb_titles: {
				cs: 'menu.merchant-console-cs-notice',
				certification: 'menu.merchant-console-certification-kyc',
			},
			lnb_item: [],
			lnb_title: '',
			menuChange: window.innerWidth < 768,
			iconCustomerServiceTitle,
		};
	},
	components: {
		Header,
		HeaderM,
		MenuRoutes,
	},
	created() {
		if (this.lnb) {
			if (this.$route.name.includes('cs')) {
				this.lnb_item = this.lnb_items.cs;
				this.lnb_title = this.lnb_titles.cs;
			} else {
				this.lnb_item = this.lnb_items.certification;
				this.lnb_title = this.lnb_titles.certification;
			}
		}
		window.addEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
			this.width = window.innerWidth;
			this.menuChange = this.width < 768;
		},
	},
};
</script>
<style scoped>
.store_container {
	display: flex;
	width: 100%;
	min-height: 862px;
}
.merchant_lnb.card {
	padding: 30px;
}
.merchant_layout.lnb .store_container {
	gap: 10px;
}
.store_menu {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	border-radius: 20px;
	position: relative;
	top: 0;
	left: 0;
}
.store_menu h3 {
	font-weight: 600;
	font-size: 20px;
	line-height: 22px;
	display: flex;
	align-items: center;
	gap: 4px;
	margin-bottom: 30px;
}
.store_menu .customer_info_menu {
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
}
.store_menu .customer_info_menu li a {
	display: block;
	padding: 15px;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #7f8894;
	background-color: #f9fafb;
	border-radius: 12px;
}

.store_menu ul li a.router-link-active {
	color: #fff;
	background: #2a5cda;
}

.operating_time {
	padding: 20px;
	border-radius: 12px;
	background-color: #2a5cda;
}
.operating_time p {
	color: #fff;
	margin-bottom: 5px;
	font-weight: 600;
	font-size: 16px;
	line-height: 18px;
}
.operating_time span {
	color: #fff;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
}
.border_bottom {
	border-bottom: 1px solid #fff;
	padding-bottom: 15px;
}

@media screen and (max-width: 768px) {
	.store_container {
		min-height: auto;
	}
	.merchant_layout.lnb .container-wrap {
		padding-top: 80px;
	}
	.merchant_layout.lnb .store_container {
		flex-direction: column;
		gap: 0;
	}
	.merchant_layout .merchant_lnb {
		width: 100%;
		min-height: auto;
		border-radius: 12px;
	}
	.store_menu .customer_info_menu {
		display: none;
	}
	.operating_time {
		display: none;
	}
	.merchant_lnb.card {
		padding: 10px;
	}
	.store_menu h3 {
		margin-bottom: 0;
		font-size: 16px;
		line-height: 18px;
	}
	.store_menu h3 img {
		width: 20px;
		height: 20px;
	}
}
</style>
